'use strict';

export function truncate(string, length) {
    if (string && string.length > length) {
        var truncated = string.substring(0, length);
        var lastSpace = truncated.lastIndexOf(' ');

        return truncated.substring(0, lastSpace) + '...';
    }

    return string;
}

export function escapeDoubleQuotes(str) {
    if (!str || typeof str !== 'string') {
        return str;
    }

    return str.replace(/\\([\s\S])|(")/g, '\\$1$2');
}

export function escapeHtmlTags(str) {
    if (!str || typeof str !== 'string') {
        return '';
    }

    const replacements = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        "'": '&#39;',
        '"': '&quot;',
    };

    return str.replace(/[&<>'"]/g, (found) => {
        return replacements[found];
    });
}

export function unEscapeHtml(str) {
    const replacements = {
        '&amp;': '&',
        '&lt;': '<',
        '&gt;': '>',
        '&#39;': "'",
        '&quot;': '"',
    };

    return str.replace(/&amp;|&lt;|&gt;|&#39;|&quot;/g, (found) => {
        return replacements[found];
    });
}

export function normalize(str) {
    str = str.trim();
    if (str.length === 0) {
        return '';
    }

    // Removes non ASCII and punctuation etc
    /* eslint-disable no-control-regex */
    str = str
        .replace(/[~`!@#$%^&*(){}\[\];:"'<,>?\/\\|_+=]/g, '')
        .replace('&', 'och')
        .toLowerCase()
        .replace(/[åä]/g, 'a')
        .replace(/ö/g, 'o')
        .replace(/[^\x00-\x7F]/g, '');

    /* eslint-enable no-control-regex */
    return str.trim().replace(/\s+/g, '-');
}
